// @flow
import React, { useMemo } from 'react';
import moment from 'moment-timezone';

import { Stock } from 'app/common/layouts/ecart';


type Props = {
  status: 'issued' | 'not_issued',
  datetime: ?string,
  timezone: string,
};

const ItemStatus = ({ status, datetime, timezone }: Props) => {
  const time = useMemo(() => (datetime
    ? moment(datetime).tz(timezone).format('DD.MM.YY HH:mm')
    : ''
  ), [datetime, timezone]);

  if (status === 'issued') {
    return (
      <Stock>{`Выдан ${time}`}</Stock>
    );
  }

  return (
    <div>
      <Stock>{'Есть на складе'}</Stock>
    </div>
  );
};

export default ItemStatus;
